import { Stack, useTheme } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { Typography } from "@foodpilot/foods";
import { ReactNode } from "react";

export const controlWidth = (theme: Theme) => ({ width: "100%", maxWidth: theme.spacing(40) });

export const Section = ({
    title,
    description,
    children,
}: {
    title: string;
    description?: string;
    children: ReactNode;
}) => {
    const theme = useTheme();

    return (
        <Stack
            gap={theme.spacing(3)}
            sx={{
                paddingBottom: theme.spacing(4),
                borderBottom: `1px solid ${theme.custom.grey[500]}`,
                "&:last-of-type": { borderBottom: "none", paddingBottom: 0 },
            }}
        >
            <Stack gap={theme.spacing(0.5)}>
                <Typography variant="h4" component="h3">
                    {title}
                </Typography>
                {description !== undefined && (
                    <Typography variant="small-medium" sx={{ color: theme.custom.grey[2000] }}>
                        {description}
                    </Typography>
                )}
            </Stack>
            {children}
        </Stack>
    );
};

export const Field = ({
    label,
    fullWidth = false,
    children,
}: {
    label: string;
    fullWidth?: boolean;
    children: ReactNode;
}) => {
    const theme = useTheme();

    return (
        <Stack
            role="group"
            aria-label={label}
            gap={theme.spacing(1)}
            sx={fullWidth ? { width: "100%" } : { ...controlWidth(theme) }}
        >
            <Typography variant="small-medium" sx={{ color: theme.custom.grey[2800] }}>
                {label}
            </Typography>
            {children}
        </Stack>
    );
};
